import React from 'react';
import {Element as ScrollElement} from 'react-scroll';

import logo from '../../../static/images/logo--white.svg';

import SocialLink from './SocialLink';
import PointerArrow from "./PointerArrow";
import UpperBackground from "./UpperBackground";


const UpperPart = () => (
    <div className="upper-part">
        <UpperBackground />

        <img className="logo logo--upper horizontal-centered" src={logo} alt="Novastar" />
        <div className="welcome-text horizontal-centered">
            <h1>Novastar is here</h1>
            <p>
                What makes for a great online shopping experience? Could it be the right products, unbeatable prices,
                fast shipping or the best customer support in town? We believe all of these are key in building a better
                online store for everyone.
            </p>
            <p>
                Novastar brings you a wide selection of home appliances and electronics at a fantastic price point.
                Find, compare and select the products that make your life easier. We take pride in building an
                innovative online store that’s easy and enjoyable to use for all of us.
            </p>
            <p>
                Join our mission in taking online shopping to the next level. Starting from this summer.
            </p>
            <div className="social--links">
                <SocialLink url={DJ_CONST.SOCIAL_LINKS.facebook} type="facebook" transparent />
                <SocialLink url={DJ_CONST.SOCIAL_LINKS.twitter} type="twitter" transparent />
                <SocialLink url={DJ_CONST.SOCIAL_LINKS.instagram} type="instagram" transparent />
            </div>
        </div>
        <PointerArrow to="lower" duration={600} />
        <ScrollElement id="lower" name="lower" />
    </div>
);

export default UpperPart;



// WEBPACK FOOTER //
// ./src/components/UpperPart.js